import Vue from 'vue'
import {
  getToken,
  setToken,
  removeToken
} from '@/utils/auth'

// 引入你的 axios 实例（推荐）
import axios from '@/plugins/http'

function data() {
  return {
    hasLogin: false,
    access: '',
    refresh: '',
    id: -1,
    nickname: '',
    avatar: '',
    type: '',
    wh_id: -1,
    email: '',
    taobao_account: '',
    prefix: '',
    phone: '',
    activation: 0,
    score: '',
    last_login_time: 0,
    ship_limit_status: -1,
    member_code: '',
    jiyun_page_banner: null
  }
}

export default {
  namespaced: true,
  state: data,
  mutations: {
    SET_TOKEN: (state, token) => {
      setToken(token)
      Object.assign(state, token)
    },
    SET_DATA: (state, data) => {
      Object.assign(state, data)
    },
  },
  actions: {
    ClearJiyunPageBanner({ commit }) {
      commit('SET_DATA', { jiyun_page_banner: null })
    },
    Login({ commit }, user) {
      commit('SET_DATA', { ...user, hasLogin: true })
    },
    Refresh({ commit }, token) {
      commit('SET_TOKEN', token)
    },
    // 登出
    LogOut({ commit }) {
      return new Promise((resolve) => {
        axios
          .get('/User/logout')
          .finally(() => {
            commit('SET_TOKEN', data())
            removeToken()
            resolve()
          })
      })
    }
  }
}

export { data }